module.exports = __webpack_public_path__ + "static/media/Landingmobile.8984414d.png";